// extracted by mini-css-extract-plugin
export default {"buddyCard":"Z7tAMw0_lqcoZmz1JJwa","cta":"aUljYRo4TCoKtorV7dc8"};